import { id } from "date-fns/locale/id";
import { apiClient } from "./apiConfig";
import { gameMasterAPI } from "./gameMasterAPI";

import { SESSION_ID } from "./apiConfig";

/**
 * API service for authentication functionality
 */
export const partyManagerAPI = {
	getPartyActivity: async (contestID, partyID) => {
		const response = await apiClient.get(
			`/getpartyactivityfeed/?contestID=${contestID}&partyID=${partyID}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},
	getContestInfo: async (contestID) => {
		// Use the cached version from gameMasterAPI to prevent duplicate calls
		return await gameMasterAPI.getContestInfo(contestID);
	},
	getMyParty: async (contestID = null, memberID, partyID = null) => {
		const response = await apiClient.get(
			`/getparties/?memberid=${memberID}&${contestID ? `contestid=${contestID}` : ""}${partyID ? `&partyID=${partyID}` : ""}&ringleader=true`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	// Get Party info for a member (without ringleader restriction)
	getMemberParty: async (contestID, memberID) => {
		const response = await apiClient.get(
			`/getparties/?memberid=${memberID}&contestid=${contestID}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	// Get Party lumens
	getPartyLumens: async (contestID, partyID) => {
		const response = await apiClient.get(
			`/getpartylumens/?contestid=${contestID}&partyid=${partyID}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	// Get Party members
	getPartyMembers: async (contestid, partyid) => {
		const response = await apiClient.get(
			`/getpartymembers/?contestid=${contestid}&partyid=${partyid}`,
			{ sessionid: SESSION_ID() }
		);
		return response.data;
	},

	// Get parties that the ringleader has created (kept for potential future use)
	getRingleaderParties: async (memberID) => {
		console.log("📞 Calling getRingleaderParties for memberID:", memberID);
		const response = await apiClient.get(
			`/ringleadergetparties/?memberID=${memberID}`,
			{
				params: {
					sessionid: SESSION_ID(),
				},
			}
		);
		return response.data;
	},

	// Update a member's score --> for party challenge bonus points
	updateMemberScore: async (
		partyid,
		contestid,
		memberid,
		action,
		desc,
		new_bonus,
		score
	) => {
		const response = await apiClient.post(`/addscoretopartymember/`, {
			sessionid: SESSION_ID(),
			partyid,
			contestid,
			memberid,
			action,
			desc,
			new_bonus,
			score,
		});
		return response.data;
	},

	// Create or update a party role
	createUpdateRole: async (
		memberid,
		partyid,
		partyname,
		contestid,
		role,
		membername
	) => {
		const response = await apiClient.post(`/createOrUpdatePartyRole/`, {
			sessionid: SESSION_ID(),
			memberID: memberid,
			partyID: partyid,
			partyName: partyname,
			contestID: contestid,
			role,
			memberName: membername,
		});
		return response.data;
	},

	// Accept party invitation --> used also for gamemaster-recruited invites and member-recruited invites
	acceptInvite: async (
		partyID = 0,
		contestID = 0,
		memberID,
		role,
		type,
		partyName,
		userName,
		override = false
	) => {
		const payload = {
			partyid: parseInt(partyID) || 0,
			sessionid: SESSION_ID(),
			contestid: contestID || 0,
			role,
			memberid: memberID,
			type,
			partyname: partyName,
			membername: userName,
		};

		if (override) {
			payload.override = true;
		}

		console.log("Accept invite payload:", payload);
		console.log("PartyID being sent:", partyID);

		const response = await apiClient.post(`/acceptinvite/`, payload);
		return response.data;
	},

	// Get party invite details
	getInviteDetails: async (partyID, contestID) => {
		const response = await apiClient.get(`/getPartyInviteDetails/`, {
			params: {
				sessionid: SESSION_ID(),
				partyID,
				contestID,
			},
		});
		return response.data;
	},

	//enroll a party into a contest
	enrollParty: async (contestID, partyID, ringleaderID) => {
		const response = await apiClient.post(`/enrollparty/`, {
			sessionid: SESSION_ID(),
			contestid: contestID,
			ringleaderid: ringleaderID,
			partyid: partyID,
		});
		return response.data;
	},
};
